import { AxiosError } from "axios";

import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";
import { IBoasVindas } from "../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/BoasVindas";
import { ITipoAtendimento } from "../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/TipoAtendimento";
import { AgendarAdesaoRequest } from "../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/AgendarAdesaoRequest";
import { IHorarioDisponivel } from "../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/HorarioDisponivel";

export const getBoasVindasAdesao = async (): Promise<IBoasVindas> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/GetBoasVindasAdesao", { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const getTipoAtendimentoAdesao = async (): Promise<ITipoAtendimento> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("Cronicos/GetTipoAtendimentoAdesao", { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const getHorariosDisponiveisPeriodoAdesao = async (params: any): Promise<IHorarioDisponivel[]> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("Cronicos/GetHorariosDisponiveisPeriodoAdesao", { headers, params });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const agendarAdesao = async (data: AgendarAdesaoRequest): Promise<Response | null> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.post("Cronicos/AgendarAdesao", data, { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};
